export const SCREEN_SIZES = {
	xs: 480,
	sm: 720,
	md: 992,
	lg: 1200,
	xl: 1440
}
